// src/hooks/useOperatingAoiInit.js
//
// App-bootstrap hook. Fetches the org's operating AOIs so the TopNav
// picker has options to render, but does NOT auto-select one. The
// session starts with activeOperatingAoiId=null — the "open" state.
// The full entitled imagery catalog loads via useSyncOperatingAoiImagery
// firing with null and calling loadCatalog() (no-arg).
//
// This is an intentional change from the original auto-pick-the-default
// behavior: operators now choose their workbench explicitly. The yellow
// nudge in PanelHeader prompts them to do so.

import { useEffect } from "react";
import { fetchWithAuth } from "../api/fetchWithAuth";
import { useOperatingAoiContext } from "../stores/useOperatingAoiContext";

export function useOperatingAoiInit() {
  const setOperatingAois = useOperatingAoiContext(s => s.setOperatingAois);

  // Fetch only — no auto-select.
  useEffect(() => {
    async function init() {
      try {
        const res = await fetchWithAuth("/api/v1/operating-aois");
        if (!res.ok) return;

        const data = await res.json();
        const aois = Array.isArray(data.operating_aois) ? data.operating_aois : [];

        setOperatingAois(aois);
      } catch (err) {
        console.error("[useOperatingAoiInit] failed:", err);
      }
    }

    init();
    // run once at session start; setOperatingAois is a stable Zustand
    // action ref so it's safe to omit from deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}